var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page"},[_c('h1',[_vm._v(_vm._s(_vm.welcomeMessage))]),_c('p',[_vm._v("Welcome to our new website!")]),_c('button',{on:{"click":_vm.incrementCount}},[_vm._v("Click me: "+_vm._s(_vm.count))])])
}
var staticRenderFns = []

export { render, staticRenderFns }